module.exports = __webpack_public_path__ + "img/australia-respiratory-diseases-female.95455324.png";